import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toApiError } from '@/api/errorHandler';
import type { ApiError, DashboardStats } from '@/models';
import { dashboardService } from './dashboardService';
import type { AsyncStatus } from '@/types';

export interface DashboardState {
  stats: DashboardStats | null;
  status: AsyncStatus;
  error: string | null;
}

const initialState: DashboardState = { stats: null, status: 'idle', error: null };

export const fetchDashboard = createAsyncThunk<DashboardStats, void, { rejectValue: ApiError }>(
  'dashboard/fetch',
  async (_, { rejectWithValue }) => {
    try {
      return await dashboardService.getStats();
    } catch (err) {
      return rejectWithValue(toApiError(err));
    }
  },
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboard.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.stats = action.payload;
      })
      .addCase(fetchDashboard.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.message ?? 'Failed to load dashboard';
      });
  },
});

export default dashboardSlice.reducer;
